import axios from "axios";
import AuthVerifyService from "../common/AuthVerify";

const API_URL = "/api/v1/auth/";

const sendSignupOtp = (email) => {
  return axios.post(API_URL + "signup/send-otp", { email });
};

const register = (username, email, password) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  return axios
    .post(API_URL + "signin", {
      username,
      password
    })
    .then(response => {
      if (response.data.accessToken) {
        console.log("登录成功,token:", response.data.accessToken);
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
};

const forgetPassword = (email) => {
  return axios.post(API_URL + "forget-password", { email });
};

const verifyOTP = (email, otp, purpose = "password_reset") => {
  return axios.post(API_URL + "verify-otp", { email, otp, purpose });
};

const updatePassword = (email, password) => {
  return axios.post(API_URL + "update-password", { email, password });
};

const logout = () => {
  if (localStorage.getItem("user")) localStorage.removeItem("user");
  // return axios.post(API_URL + "signout").then((response) => {
  //   return response.data;
  // });
};

const getCurrentUser = () => {
  const user = localStorage.getItem("user");

  if (user) {
    const token = JSON.parse(user).accessToken
    const decodedJwt = AuthVerifyService.parseJwt(token);
    if (decodedJwt?.exp * 1000 < Date.now()) {
      return null;
    }
  }

  if (!user) return null;

  return JSON.parse(user);
};

// 创建拦截器
axios.interceptors.request.use(
  config => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accessToken) {
      config.headers = config.headers || {};
      const hasCustomAuthorization = Boolean(config.headers['Authorization'] || config.headers['authorization']);

      // Keep JWT token for legacy backend routes unless caller explicitly sets Authorization.
      if (!config.headers['x-access-token']) {
        config.headers['x-access-token'] = user.accessToken;
      }

      // Do not overwrite API-key Bearer headers used by /api/v2 Try Endpoint.
      if (!hasCustomAuthorization) {
        config.headers['Authorization'] = `Bearer ${user.accessToken}`;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 拦截响应处理401错误
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      const requestUrl = String(error?.config?.url || "");
      const isApiKeyRequest = requestUrl.includes("/api/v2");

      // Avoid noisy token-expired logs for API-key auth failures.
      if (!isApiKeyRequest) {
        // Caller-level screens can decide how to prompt re-login.
      }
    }
    return Promise.reject(error);
  }
);

const AuthService = {
  sendSignupOtp,
  register,
  login,
  forgetPassword,
  verifyOTP,
  updatePassword,
  logout,
  getCurrentUser,
}

export default AuthService;

export function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.accessToken) {
    return { 
      'x-access-token': user.accessToken,
      'Authorization': `Bearer ${user.accessToken}`
    };
  } else {
    return {};
  }
}
